// extracted by mini-css-extract-plugin
export default {"horizonatalLine":"Team_horizonatalLine__LDul1"};